import { Link } from "react-router-dom";
import { footerLinks, footerNavigationGroups, siteMeta } from "../../content/site";
import { ButtonLink } from "../ui/Button";

export const Footer = () => (
  <footer className="border-t-4 border-[#CEDC00] bg-[#0E1C2C] text-slate-300">
    <div className="section-shell md:py-24">
      <div className="grid gap-12 xl:grid-cols-[1.2fr_0.8fr_0.8fr] xl:items-start">
        <div className="space-y-6 max-w-xl">
          <p className="eyebrow text-[#CEDC00] font-bold tracking-wider">Education Project</p>
          <h2 className="text-3xl font-display font-semibold leading-tight text-white md:text-4xl">
            A nonprofit and lifelong-learning ecosystem platform for education in its broadest sense.
          </h2>
          <p className="text-slate-300/95 leading-relaxed text-[0.95rem]">{siteMeta.trustStatement}</p>
          <div className="flex flex-col gap-3 sm:flex-row pt-2">
            <ButtonLink to="/community" variant="primary" className="text-sm uppercase tracking-wider">
              Partner With Us
            </ButtonLink>
            <ButtonLink to="/donate" variant="lime" className="text-sm uppercase tracking-wider">
              Support the Mission
            </ButtonLink>
          </div>
        </div>

        {footerNavigationGroups.map((group) => (
          <div key={group.title} className="space-y-5">
            <h3 className="text-lg font-display font-bold text-white uppercase tracking-wider">{group.title}</h3>
            <div className="flex flex-col gap-3.5 text-[0.95rem]">
              {group.links.map((item) => (
                <Link key={item.href} to={item.href} className="text-slate-300 hover:text-[#0293cc] transition-colors">
                  {item.label}
                </Link>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="mt-16 flex flex-col gap-6 border-t border-white/10 pt-8 text-[0.875rem] text-slate-400 md:flex-row md:items-center md:justify-between">
        <p>{siteMeta.trustStatement}</p>
        <div className="flex flex-wrap gap-6">
          {footerLinks.map((item) => (
            <Link key={item.href} to={item.href} className="hover:text-[#0293cc] transition-colors">
              {item.label}
            </Link>
          ))}
        </div>
      </div>
    </div>
  </footer>
);
